// value is acos, in percentage form
// target is target_acos, in percentage form
// spend is cost, in dollars
export const determineColor = (
    value: number | string,
    target: number | string,
    spend: number | string | null = null,
): string => {
    value = Number(value)
    spend = Number(spend)

    const targetAcos = Number(target)
    if (isNaN(targetAcos)) {
        return ''
    }

    let color
    switch (true) {
        case value == 0 && spend > 0:
            // Spend, but no sales
            color = 'text-red-600'
            break
        case value < targetAcos:
            // Under target
            color = 'text-green-600'
            break
        case value <= targetAcos * 2:
            // Over target, but not too much
            color = 'text-yellow-600'
            break
        default:
            // Over target
            color = 'text-red-600'
            break
    }

    return color
}
